<template>
    <component v-bind:is="linkType"
               :href="href"
               :target="target"
               data-trc="productThumb.price"
               v-on:product-clicked="productClicked">

        <span class="dml-price-wrap">
            <span v-if="priceModel.discount" class="dml-price dml-price--promo" data-t="8.4">{{priceModel.price}}</span>
            <span v-if="priceModel.discount" class="dml-price dml-price--old _to" data-t="8.3">{{priceModel.oldPrice}}*</span>
            <span v-if="!priceModel.discount" class="dml-price dml-price--regular" data-t="8.3">{{priceModel.price}}</span>
        </span>
    </component>
</template>
<script>
    import LightboxLink from './lightbox-link';

    export default {
        name: 'dm-product-price',
        components: {
            'dm-lightbox-link': LightboxLink,
        },
        props: {
            priceModel: {
                type: Object,
                required: true
            },
            linkType: {
                type: String,
                default: 'a',
                required: false,
            },
            target: {
                type: String,
                required: false,
            },
            href: {
                type: String,
                required: false,
            }
        },
        methods: {
            productClicked(e) {
                this.$emit('product-clicked', e);
            },
        }
    };
</script>
